import { Form } from "react-bootstrap";
import { t } from "../i18n";

function RowsPerPageSelector({ isDataFetched, dataLength, itemsPerPage, setItemsPerPage, setCurrentPage, language, threshold = 5 }) {
    if (!isDataFetched || dataLength <= threshold) {
        return null;
    }

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
        }}>
            <label style={{
                fontSize: '14px',
                color: 'var(--text-primary)',
                marginBottom: '0',
                whiteSpace: 'nowrap',
                fontWeight: '500'
            }}>
                {t('common.rowsPerPage', language)}
            </label>
            <Form.Select
                value={itemsPerPage}
                onChange={(e) => {
                    setItemsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                }}
                style={{
                    width: '75px',
                    padding: '6px 10px',
                    fontSize: '14px',
                    border: '1px solid var(--border-color)',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                }}
            >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={25}>25</option>
            </Form.Select>
        </div>
    );
}

export default RowsPerPageSelector;
